import { createApp } from 'vue';
import App from './App.vue';

// Vue libraries
import router from './router';

// CSS / animations
import './index.css';

// App
createApp(App).use(router).mount('#app');